<template>
  <LottieAnimation ref="anim" :animationData="loader" :loop="true" />
</template>

<script>
import loader from '../../public/animation/workhy_logo.json';
export default {
  data() {
    return {
      loader,
    };
  },
  name: 'Lottie',
};
</script>
